import Vue from 'vue';
export default Vue.component('ed-empty-viewer', { name: 'ed-empty-viewer'});